import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Страница 404 - Не найдено
 * Отображается когда пользователь переходит на несуществующий маршрут
 */
export const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-base-200 flex items-center justify-center p-4">
      <div className="text-center">
        <div className="mb-8">
          <i className="fas fa-exclamation-triangle text-6xl text-warning mb-4"></i>
          <h1 className="text-4xl font-bold text-base-content mb-2">404</h1>
          <h2 className="text-xl font-semibold text-base-content mb-4">
            Страница не найдена
          </h2>
          <p className="text-base-content/60 max-w-md mx-auto">
            Запрашиваемая страница не существует или была перемещена. Проверьте
            правильность адреса или вернитесь на главную страницу.
          </p>
        </div>

        <div className="space-y-4">
          <Link to="/dashboard" className="btn btn-primary">
            <i className="fas fa-home mr-2"></i>
            Вернуться на главную
          </Link>

          <div className="text-sm text-base-content/40">
            Или воспользуйтесь навигацией выше
          </div>
        </div>
      </div>
    </div>
  );
};
